import { initResume } from "@/assets/variables/inits/resume.init";

export const initExpoEmployee = (form = {}) => ({
    ...(form || {}),

    _terms: [...(form?._terms || [])],

    _program: form?._program || null,
    _user: form?._user || null,

    info: {
        ...(form?.info || {}),
        desc: form?.info?.desc || null,
        name: form?.info?.name || null,
        phone: form?.info?.phone || null,
        email: form?.info?.email || null,
    },

    resume: initResume(form?.resume),
});
